/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsLokaliseString,
    ControlcenterMelcoControlCenterModelsLokaliseStringFromJSON,
    ControlcenterMelcoControlCenterModelsLokaliseStringFromJSONTyped,
    ControlcenterMelcoControlCenterModelsLokaliseStringToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsLokaliseString>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString
     */
    list: Array<ControlcenterMelcoControlCenterModelsLokaliseString>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseStringFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseStringToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseStringToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


